<div class="row">
  <div class="col">
    <div class="content-header">Swiper</div>
    <p class="content-sub-header mb-1">Swiper is the free and most modern mobile touch slider with hardware accelerated
      transitions and amazing native behavior</p>
  </div>
</div>

<!-- default swiper start -->
<section id="swiper-default">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Default</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-default swiper-container" [swiper]="swiperDefaultConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-1.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-2.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-4.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-13.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-7.jpg" alt="banner"></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- default swiper ends -->

<!-- navigations swiper start -->
<section id="swiper-navigations">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Navigations</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-navigations swiper-container" [swiper]="swiperNavigationConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-7.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-4.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-14.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-3.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-2.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Arrows -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- navigations swiper ends -->

<!-- pagination swiper start -->
<section id="swiper-pagination">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Pagination</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-paginations swiper-container" [swiper]="swiperPaginationConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-12.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-9.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-8.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-7.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-20.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- pagination swiper ends -->

<!-- progress swiper start -->
<section id="swiper-progress">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Progress</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-progress swiper-container" [swiper]="swiperProgressConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-8.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-7.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-20.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-5.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-4.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                          <!-- Add Arrows -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- progress swiper ends -->

<!-- Multiple Slides Per View swiper start -->
<section id="swiper-multiple">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Multiple Slides Per View</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-multiple swiper-container" [swiper]="swiperMultipleConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-34.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-31.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-32.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-33.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-35.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Multiple Slides Per View swiper ends -->

<!-- centered-slides option-1 swiper start -->
<section id="swiper-centered-slides">
  <div class="row">
      <div class="col-12">
          <div class="card bg-transparent shadow-none">
              <div class="card-header">
                  <h4 class="card-title">Centered Slides option-1</h4>
              </div>
              <div class="card-content">
                  <div class="card-body py-0">
                      <div class="swiper-centered-slides swiper-container p-3" [swiper]="swiperCenterOpt1Config">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide rounded swiper-shadow"><i class="fa fa-google font-large-1"></i>
                                  <div class="swiper-text pt-md-2 pt-sm-1">Getting Started</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow"><i class="fa fa-facebook font-large-1"></i>
                                  <div class="swiper-text pt-md-2 pt-sm-1">Pricing & Plans</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow"><i class="fa fa-twitter font-large-1"></i>
                                  <div class="swiper-text pt-md-2 pt-sm-1">Sales Question</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow"><i class="fa fa-instagram font-large-1"></i>
                                  <div class="swiper-text pt-md-2 pt-sm-1">Usage Guides</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow"><i class="fa fa-google font-large-1"></i>
                                  <div class="swiper-text pt-md-2 pt-sm-1">General Guide</div>
                              </div>
                          </div>
                          <!-- Add Arrows -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- centered-slides option-1 swiper ends -->

<!-- centered-slides option-2 swiper start -->
<section id="swiper-centered-slides-2">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Centered Slides option-2</h4>
              </div>
              <div class="card-content">
                  <div class="card-body pt-0">
                      <div class="swiper-centered-slides-2 swiper-container p-3" [swiper]="swiperCenterOpt2Config">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide rounded swiper-shadow py-2 px-4 d-flex">
                                  <i class="fa fa-google d-flex align-items-center font-medium-3 mr-2"></i>
                                  <div class="swiper-text">Getting Started</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow py-2 px-4 d-flex">
                                  <i class="fa fa-facebook d-flex align-items-center font-medium-3 mr-2"></i>
                                  <div class="swiper-text">Pricing & Plans</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow py-2 px-4 d-flex">
                                  <i class="fa fa-twitter d-flex align-items-center font-medium-3 mr-2"></i>
                                  <div class="swiper-text">Sales Question</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow py-2 px-4 d-flex">
                                  <i class="fa fa-instagram d-flex align-items-center font-medium-3 mr-2"></i>
                                  <div class="swiper-text">Usage Guides</div>
                              </div>
                              <div class="swiper-slide rounded swiper-shadow py-2 px-4 d-flex">
                                  <i class="fa fa-google d-flex align-items-center font-medium-3 mr-2"></i>
                                  <div class="swiper-text">General Guide</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- centered-slides option-2 swiper ends -->

<!-- Fade Effect swiper start -->
<section id="swiper-fade-effect">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Fade Effect</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-fade-effect swiper-container" [swiper]="swiperFadeEffectConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-20.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-19.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-18.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-17.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-16.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination swiper-pagination-white"></div>
                          <!-- Add Arrows -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Fade Effect swiper ends -->

<!-- 3d cube effect swiper start -->
<section id="swiper-cube-effect">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">3-D cube Effect</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-cube-effect swiper-container mb-3" [swiper]="swiperCubeEffectConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-21.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-22.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-23.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-24.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination swiper-pagination-white"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- 3d cube effect swiper ends -->

<!-- coverflow effect swiper start -->
<section id="swiper-coverflow">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">3d Effect Coverflow Effect</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-coverflow swiper-container" [swiper]="swiperCoverflowEffectConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-35.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-39.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-38.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-37.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-36.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-34.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-33.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-32.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-31.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- coverflow effect swiper ends -->

<!-- autoplay swiper start -->
<section id="swiper-autoplay">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Autoplay</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-autoplay swiper-container" [swiper]="swiperAutoplayConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-20.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-7.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-8.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-9.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-10.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-11.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                          <!-- Add Arrows -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- autoplay swiper ends -->

<!-- parallax swiper start -->
<section id="swiper-parallax">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Parallax</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <!-- Swiper -->
                      <div class="swiper-parallax swiper-container" [swiper]="swiperParallaxConfig">
                          <div class="parallax-bg" data-swiper-parallax="-23%"><img class="img-fluid" src="assets/img/banner/parallax-4.jpg" alt="banner"></div>
                          <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                  <div class="title" data-swiper-parallax="-300">Slide 1</div>
                                  <div class="subtitle mb-1" data-swiper-parallax="-200">Subtitle</div>
                                  <div data-swiper-parallax="-100">
                                      <p class="font-small-2">Cake biscuit candy canes cake macaroon cheesecake gummies carrot cake. Chupa chups pastry halvah gummi bears powder. Wafer macaroon gummi bears tart soufflé chocolate cake.</p>
                                  </div>
                              </div>
                              <div class="swiper-slide">
                                  <div class="title" data-swiper-parallax="-300" data-swiper-parallax-opacity="0">Slide 2
                                  </div>
                                  <div class="subtitle mb-1" data-swiper-parallax="-200">Subtitle</div>
                                  <div data-swiper-parallax="-100">
                                      <p class="font-small-2">Pie gummi bears macaroon cupcake. Dessert dragée apple pie lollipop cake gummies lemon drops chupa chups apple pie. Ice cream sugar plum sweet roll cake candy fruitcake soufflé.</p>
                                  </div>
                              </div>
                              <div class="swiper-slide">
                                  <div class="title" data-swiper-parallax="-300">Slide 3</div>
                                  <div class="subtitle mb-1" data-swiper-parallax="-200">Subtitle</div>
                                  <div data-swiper-parallax="-100">
                                      <p class="font-small-2">Lemon drops oat cake marzipan cheesecake sweet. Dragée chocolate bar gingerbread pudding tiramisu. Ice cream croissant chupa chups sesame snaps jujubes sesame snaps ice cream fruitcake.</p>
                                  </div>
                              </div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                          <!-- Add Navigation -->
                          <div class="swiper-button-prev"></div>
                          <div class="swiper-button-next"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- parallax swiper ends -->

<!-- Lazy loading swiper start -->
<section id="swiper-lazy">
  <div class="row">
      <div class="col-12">
          <div class="card ">
              <div class="card-header">
                  <h4 class="card-title">Lazy Loading</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-lazy-loading swiper-container" [swiper]="swiperLazyLoadingConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                  <!-- Required swiper-lazy class and image source specified in data-src attribute -->
                                  <img src="assets/img/banner/banner-9.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <!-- Preloader image -->
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                              <div class="swiper-slide">
                                  <img src="assets/img/banner/banner-8.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                              <div class="swiper-slide">
                                  <img src="assets/img/banner/banner-7.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                              <div class="swiper-slide">
                                  <img src="assets/img/banner/banner-20.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                              <div class="swiper-slide">
                                  <img src="assets/img/banner/banner-5.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                              <div class="swiper-slide">
                                  <img src="assets/img/banner/banner-4.jpg" class="swiper-lazy img-fluid" alt="banner">
                                  <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                              </div>
                          </div>

                          <!-- Add Pagination -->
                          <div class="swiper-pagination swiper-pagination-white"></div>
                          <!-- Navigation -->
                          <div class="swiper-button-next"></div>
                          <div class="swiper-button-prev"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Lazy loading swiper ends -->

<!-- Responsive Breakpoints swiper start -->
<section id="swiper-responsive-breakpoints">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Responsive Breakpoints</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="swiper-responsive-breakpoints swiper-container" [swiper]="swiperResponsiveBreakpointsConfig">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-30.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-31.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-32.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-33.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-34.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-35.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-36.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-37.jpg" alt="banner"></div>
                              <div class="swiper-slide"><img class="img-fluid" src="assets/img/banner/banner-38.jpg" alt="banner"></div>
                          </div>
                          <!-- Add Pagination -->
                          <div class="swiper-pagination"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Responsive Breakpoints swiper ends -->

